import { VariantCard } from "./variant-card.content";
import type { StudentDisplayData } from "./types";

interface StudentDisplayCardProps {
  student: StudentDisplayData;
  variant: "admin" | "provider";
}

const DEFAULT_TITLES = {
  admin: "Élève",
  provider: "Élève",
} as const;

/**
 * Shared component to display student information.
 * Used by both admin and provider portal views.
 */
export const StudentDisplayCard = ({ student, variant }: StudentDisplayCardProps) => {
  const title = DEFAULT_TITLES[variant];

  return (
    <VariantCard title={title} variant={variant}>
      <div className="grid grid-cols-2 gap-2 text-sm">
        <div>
          <span className="text-muted-foreground">Prénom :</span> {student.firstName}
        </div>
        <div>
          <span className="text-muted-foreground">Nom :</span> {student.lastName}
        </div>
      </div>
    </VariantCard>
  );
};
